import { Component } from '@angular/core';

@Component({
  selector: 'fgb-player-reveal-leaderboard-page',
  templateUrl: './player-reveal-leaderboard-page.component.html',
  styleUrl: './player-reveal-leaderboard-page.component.scss',
})
export class PlayerRevealLeaderboardPageComponent {
  LeaderboardType = 101;
}
